// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/Assets/Donation/footerBackgroundImg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 119px;
  background-color: black;
}

/* Page-specific background theme overrides */
.Footer--adventure {
  background-color: #060b04 !important;
  background-image: radial-gradient(circle at 50% 30%, rgba(90, 175, 154, 0.10) 0%, rgba(6, 11, 4, 1) 70%) !important;
  margin-top: 0 !important;
  border-top: 1px solid rgba(90, 175, 154, 0.12);
}

.Footer--adventure .lastBorder {
  border-bottom: 1px solid rgba(90, 175, 154, 0.18);
}

.Footer--gear {
  background-color: #111111 !important;
  background-image: radial-gradient(circle at 50% 30%, rgba(255, 255, 255, 0.04) 0%, rgba(17, 17, 17, 1) 70%) !important;
  margin-top: 0 !important;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.Footer--gear .lastBorder {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

.footerContainer{
    padding-top: 101.25px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.footerLogo{
    width: 520px;
    height: 113px;
    transition: opacity 0.2s ease, transform 0.2s ease;
}
.footerLogo:hover {
    opacity: 0.92;
    transform: scale(1.01);
}
.footerLastRow{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 130.25px;
    gap: 15px;
}
.footerLastRowText{
    color: #94969D;
    font-size: 18px;
    font-family: "Inter", sans-serif;
    line-height: 27px;
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.2s ease;
}
.footerLastRowText:hover {
    color: #FFFFFF;
}
  .lastBorder {
    width: 60vw;
    border-bottom: 1px solid #1D1D20;
    margin-top: 60.5px;
    margin-bottom: 71px;
  }

  @media screen and (max-width: 1440px) {
    .footerContainer {
      padding-top: 100px;
    }
    .footerText {
      font-size: 14px;
    }
    .footerLogo {
      width: 390px;
      height: 85px;
  }
    .footerLastRow {
      margin-top: 56.25px;
    }
    .footerLastRowText {
      font-size: 14px;
      line-height: 20px;
    }
    .lastBorder {
      margin-top: 62px;
    }
  }

  @media screen and (max-width: 1025px) {
  .Footer {
      margin-top: 100px;
  }
  .footerContainer {
    padding-top: 100px;
    width: 100%;
}
.footerText {
  font-size: 12px;
}
.footerLogo {
  width: 195.65px;
  height: 50px;
}

.footerLastRow {
  margin-top: 39.1px;
  width: 356px;
}
.footerLastRowText {
  font-size: 12.2px;
  line-height: 14.4px;
}
.lastBorder {
  margin-top: 57.4px;
}
}

@media screen and (max-width: 768px){
  .Footer {
    margin-top: 40px;
}
  .footerContainer {
    padding-top: 60px;
}
.footerLogo {
  width: 195.65px;
  height: 50px;
}
.footerLastRow{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  gap: 5px;
}
.footerLastRowText{
  font-size: 12px;
}
.lastBorder {
  width: 100%;
}

}`, "",{"version":3,"sources":["webpack://./src/Components/Donation/Footer/Footer.css"],"names":[],"mappings":"AAGA;EACE,yDAAmF;EACnF,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC,mHAAmH;EACnH,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,sHAAsH;EACtH,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,aAAa;IACb,kDAAkD;AACtD;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,SAAS;AACb;AACA;IACI,cAAc;IACd,eAAe;IACf,gCAAgC;IAChC,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,2BAA2B;AAC/B;AACA;IACI,cAAc;AAClB;EACE;IACE,WAAW;IACX,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE;MACE,kBAAkB;IACpB;IACA;MACE,eAAe;IACjB;IACA;MACE,YAAY;MACZ,YAAY;EAChB;IACE;MACE,mBAAmB;IACrB;IACA;MACE,eAAe;MACf,iBAAiB;IACnB;IACA;MACE,gBAAgB;IAClB;EACF;;EAEA;EACA;MACI,iBAAiB;EACrB;EACA;IACE,kBAAkB;IAClB,WAAW;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;AAEA;EACE;IACE,gBAAgB;AACpB;EACE;IACE,iBAAiB;AACrB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;AACV;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n\n.Footer {\n  background-image: url(\"../../../../public/Assets/Donation/footerBackgroundImg.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 100%;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 119px;\n  background-color: black;\n}\n\n/* Page-specific background theme overrides */\n.Footer--adventure {\n  background-color: #060b04 !important;\n  background-image: radial-gradient(circle at 50% 30%, rgba(90, 175, 154, 0.10) 0%, rgba(6, 11, 4, 1) 70%) !important;\n  margin-top: 0 !important;\n  border-top: 1px solid rgba(90, 175, 154, 0.12);\n}\n\n.Footer--adventure .lastBorder {\n  border-bottom: 1px solid rgba(90, 175, 154, 0.18);\n}\n\n.Footer--gear {\n  background-color: #111111 !important;\n  background-image: radial-gradient(circle at 50% 30%, rgba(255, 255, 255, 0.04) 0%, rgba(17, 17, 17, 1) 70%) !important;\n  margin-top: 0 !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.Footer--gear .lastBorder {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.footerContainer{\n    padding-top: 101.25px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n.footerLogo{\n    width: 520px;\n    height: 113px;\n    transition: opacity 0.2s ease, transform 0.2s ease;\n}\n.footerLogo:hover {\n    opacity: 0.92;\n    transform: scale(1.01);\n}\n.footerLastRow{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 130.25px;\n    gap: 15px;\n}\n.footerLastRowText{\n    color: #94969D;\n    font-size: 18px;\n    font-family: \"Inter\", sans-serif;\n    line-height: 27px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: color 0.2s ease;\n}\n.footerLastRowText:hover {\n    color: #FFFFFF;\n}\n  .lastBorder {\n    width: 60vw;\n    border-bottom: 1px solid #1D1D20;\n    margin-top: 60.5px;\n    margin-bottom: 71px;\n  }\n\n  @media screen and (max-width: 1440px) {\n    .footerContainer {\n      padding-top: 100px;\n    }\n    .footerText {\n      font-size: 14px;\n    }\n    .footerLogo {\n      width: 390px;\n      height: 85px;\n  }\n    .footerLastRow {\n      margin-top: 56.25px;\n    }\n    .footerLastRowText {\n      font-size: 14px;\n      line-height: 20px;\n    }\n    .lastBorder {\n      margin-top: 62px;\n    }\n  }\n\n  @media screen and (max-width: 1025px) {\n  .Footer {\n      margin-top: 100px;\n  }\n  .footerContainer {\n    padding-top: 100px;\n    width: 100%;\n}\n.footerText {\n  font-size: 12px;\n}\n.footerLogo {\n  width: 195.65px;\n  height: 50px;\n}\n\n.footerLastRow {\n  margin-top: 39.1px;\n  width: 356px;\n}\n.footerLastRowText {\n  font-size: 12.2px;\n  line-height: 14.4px;\n}\n.lastBorder {\n  margin-top: 57.4px;\n}\n}\n\n@media screen and (max-width: 768px){\n  .Footer {\n    margin-top: 40px;\n}\n  .footerContainer {\n    padding-top: 60px;\n}\n.footerLogo {\n  width: 195.65px;\n  height: 50px;\n}\n.footerLastRow{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 40px;\n  gap: 5px;\n}\n.footerLastRowText{\n  font-size: 12px;\n}\n.lastBorder {\n  width: 100%;\n}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
